"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BitMap = BitMap;
exports.addClass = addClass;
exports.byteLength = byteLength;
exports.cleanArray = cleanArray;
exports.compareArray = compareArray;
exports.compareObject = compareObject;
exports.createUniqueString = createUniqueString;
exports.debounce = debounce;
exports.deepClone = deepClone;
exports.formatKeyValue = exports.downloadFileExcel = void 0;
exports.formatTime = formatTime;
exports.formatterThusandth = formatterThusandth;
exports.getQueryObject = getQueryObject;
exports.getRoleName = void 0;
exports.getTime = getTime;
exports.hasClass = hasClass;
exports.html2Text = html2Text;
exports.monthTransToEn = void 0;
exports.objectMerge = objectMerge;
exports.paddingNum = void 0;
exports.param = param;
exports.param2Obj = param2Obj;
exports.parseTime = parseTime;
exports.removeClass = removeClass;
exports.thousandFix = thousandFix;
exports.toPercent = void 0;
exports.toggleClass = toggleClass;
exports.uniqueArr = uniqueArr;
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.regexp.constructor");
require("core-js/modules/es6.regexp.match");
require("core-js/modules/es6.set");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.array.from");
require("core-js/modules/es6.regexp.split");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
require("core-js/modules/es7.string.pad-start");
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.regexp.to-string");
var _typeof2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/typeof.js"));
/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  var format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  var date;
  if ((0, _typeof2.default)(time) === 'object') {
    date = time;
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time);
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  var formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  var time_str = format.replace(/{([ymdhisa])+}/g, function (result, key) {
    var value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value];
    }
    return value.toString().padStart(2, '0');
  });
  return time_str;
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000;
  } else {
    time = +time;
  }
  var d = new Date(time);
  var now = Date.now();
  var diff = (now - d) / 1000;
  if (diff < 30) {
    return '刚刚';
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前';
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前';
  } else if (diff < 3600 * 24 * 2) {
    return '1天前';
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分';
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
function getQueryObject(url) {
  url = url == null ? window.location.href : url;
  var search = url.substring(url.lastIndexOf('?') + 1);
  var obj = {};
  var reg = /([^?&=]+)=([^?&=]*)/g;
  search.replace(reg, function (rs, $1, $2) {
    var name = decodeURIComponent($1);
    var val = decodeURIComponent($2);
    val = String(val);
    obj[name] = val;
    return rs;
  });
  return obj;
}

/**
 * @param {string} input value
 * @returns {number} output value
 */
function byteLength(str) {
  // returns the byte length of an utf8 string
  var s = str.length;
  for (var i = str.length - 1; i >= 0; i--) {
    var code = str.charCodeAt(i);
    if (code > 0x7f && code <= 0x7ff) s++;else if (code > 0x7ff && code <= 0xffff) s += 2;
    if (code >= 0xDC00 && code <= 0xDFFF) i--;
  }
  return s;
}

/**
 * @param {Array} actual
 * @returns {Array}
 */
function cleanArray(actual) {
  var newArray = [];
  for (var i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i]);
    }
  }
  return newArray;
}

/**
 * @param {Object} json
 * @returns {Array}
 */
function param(json) {
  if (!json) return '';
  return cleanArray(Object.keys(json).map(function (key) {
    if (json[key] === undefined) return '';
    return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]);
  })).join('&');
}

/**
 * @param {string} url
 * @returns {Object}
 */
function param2Obj(url) {
  var search = url.split('?')[1];
  if (!search) {
    return {};
  }
  return JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"').replace(/\+/g, ' ') + '"}');
}

/**
 * @param {string} val
 * @returns {string}
 */
function html2Text(val) {
  var div = document.createElement('div');
  div.innerHTML = val;
  return div.textContent || div.innerText;
}

/**
 * Merges two objects, giving the last one precedence
 * @param {Object} target
 * @param {(Object|Array)} source
 * @returns {Object}
 */
function objectMerge(target, source) {
  if ((0, _typeof2.default)(target) !== 'object') {
    target = {};
  }
  if (Array.isArray(source)) {
    return source.slice();
  }
  Object.keys(source).forEach(function (property) {
    var sourceProperty = source[property];
    if ((0, _typeof2.default)(sourceProperty) === 'object') {
      target[property] = objectMerge(target[property], sourceProperty);
    } else {
      target[property] = sourceProperty;
    }
  });
  return target;
}

/**
 * Compare two objects, Judgment uniqueness
 * @param {Object} target
 * @param {(Object|Array)} source
 * @returns {Object}
 */
function compareObject(obj1, obj2) {
  // console.log(obj1, obj2)

  var simpleReg = /(String|Number|Boolean|Undefined|Null)/;
  var objReg = /(Object)/;
  var arrReg = /(Array)/;

  // 传入为数组
  if (arrReg.test(Object.prototype.toString.call(obj1))) {
    return compareArray(obj1, obj2);
  }

  // 获取对象所有自身属性的属性名（可枚举的属性)
  var obj1Props = Object.keys(obj1);
  var obj2Props = Object.keys(obj2);
  if (obj1Props.length !== obj2Props.length) {
    return false;
  }

  // 递归调用判断每一个属性值是否相等
  // return obj1Props.every(prop => obj1[prop] === obj2[prop])

  return obj1Props.every(function (prop) {
    var proptype = Object.prototype.toString.call(obj1[prop]);

    // if (obj2[prop] === undefined) return false

    if (simpleReg.test(proptype)) {
      return obj1[prop] === obj2[prop];
    } else if (objReg.test(proptype)) {
      return compareObject(obj1[prop], obj2[prop]);
    } else if (arrReg.test(proptype)) {
      return compareArray(obj1[prop], obj2[prop]);
    }
  });
}
function compareArray(arr1, arr2) {
  // 判断2个数组是否相等
  var simpleReg = /(String|Number|Boolean|Undefined|Null)/;
  var objReg = /(Object)/;
  var arrReg = /(Array)/;
  if (arr1 === arr2) {
    // 如果2个数组对应的指针相同，那么肯定相等，同时也对比一下类型
    return true;
  } else {
    if (!arr1 || !arr2) {
      return true;
    }
    if (arr1.length !== arr2.length) {
      return false;
    } else {
      // 长度相同 比较值
      for (var i in arr1) {
        var proptype = Object.prototype.toString.call(arr1[i]);
        if (simpleReg.test(proptype)) {
          if (arr2.indexOf(arr1[i]) === -1) {
            return false;
          }
        } else if (objReg.test(proptype)) {
          if (!compareObject(arr1[i], arr2[i])) {
            return false;
          }
        } else if (arrReg.test(proptype)) {
          if (!compareArray(arr1[i], arr2[i])) {
            return false;
          }
        }
      }

      // for循环完成，没有出现不相等的情况，那么2个数组相等
      return true;
    }
  }
}

/**
 * @param {HTMLElement} element
 * @param {string} className
 */
function toggleClass(element, className) {
  if (!element || !className) {
    return;
  }
  var classString = element.className;
  var nameIndex = classString.indexOf(className);
  if (nameIndex === -1) {
    classString += '' + className;
  } else {
    classString = classString.substr(0, nameIndex) + classString.substr(nameIndex + className.length);
  }
  element.className = classString;
}

/**
 * @param {string} type
 * @returns {Date}
 */
function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90;
  } else {
    return new Date(new Date().toDateString());
  }
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
function debounce(func, wait, immediate) {
  var timeout, args, context, timestamp, result;
  var _later = function later() {
    // 据上一次触发时间间隔
    var last = +new Date() - timestamp;

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(_later, wait - last);
    } else {
      timeout = null;
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    context = this;
    timestamp = +new Date();
    var callNow = immediate && !timeout;
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(_later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }
    return result;
  };
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
function deepClone(source) {
  if (!source && (0, _typeof2.default)(source) !== 'object') {
    throw new Error('error arguments', 'deepClone');
  }
  var targetObj = source.constructor === Array ? [] : {};
  Object.keys(source).forEach(function (keys) {
    if (source[keys] && (0, _typeof2.default)(source[keys]) === 'object') {
      targetObj[keys] = deepClone(source[keys]);
    } else {
      targetObj[keys] = source[keys];
    }
  });
  return targetObj;
}

/**
 * @param {Array} arr
 * @returns {Array}
 */
function uniqueArr(arr) {
  return Array.from(new Set(arr));
}

/**
 * @returns {string}
 */
function createUniqueString() {
  var timestamp = +new Date() + '';
  var randomNum = parseInt((1 + Math.random()) * 65536) + '';
  return (+(randomNum + timestamp)).toString(32);
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
function hasClass(ele, cls) {
  return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'));
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
function addClass(ele, cls) {
  if (!hasClass(ele, cls)) ele.className += ' ' + cls;
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
function removeClass(ele, cls) {
  if (hasClass(ele, cls)) {
    var reg = new RegExp('(\\s|^)' + cls + '(\\s|$)');
    ele.className = ele.className.replace(reg, ' ');
  }
}
function formatterThusandth(val) {
  if (isNaN(val) || val === null) {
    // throw new TypeError('utils error, formatterThusandth ---> num is not a number')
    return '';
  }
  return ('' + val).replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, '$1,') || '';
}
function thousandFix(num) {
  return (num || 0).toString().replace(/^-?\d+/g, function (m) {
    return m.replace(/(?=(?!\b)(\d{3})+$)/g, ',');
  });
}

// 大批量数据的位图法并集交集计算，成员值需要为int型，可支持亿级数量的计算
/**
 * const maximum = 100000000 (maximum为所有成员值中预计的最大值，用以预分配内存，例如7位数的门店号，最大值为9999999)
 * const bit_map = new BitMap(maximum)
 * bit_map.addMember(item)
 * bit_map.isExist(item)
 */
function BitMap(maximum) {
  var size = maximum % 32 ? maximum / 32 + 1 : maximum / 32;
  var bit_arr = new Array(size);
  for (var i = 0; i < bit_arr.length; i++) {
    bit_arr[i] = 0;
  }
  // 在bit中添加值
  this.addMember = function (member) {
    // 决定在数组中的索引
    var arr_index = Math.floor(member / 32);
    // 决定在整数的32个bit位的哪一位
    var bit_index = member % 32;
    bit_arr[arr_index] = bit_arr[arr_index] | 1 << bit_index;
  };
  // 在bit中校验值是否存在
  this.isExist = function (member) {
    var arr_index = Math.floor(member / 32);
    var bit_index = member % 32;
    var value = bit_arr[arr_index] & 1 << bit_index;
    if (value !== 0) {
      return true;
    }
    return false;
  };
}

/**
 * 格式化枚举，统一处理
 * @param {string} key // 枚举值
 * @param {object} optionsObj // options 需要格式 {name: xxx, code: xxx}
 * @param {boolean} needDebug // debug
 * @return {string} 匹配的文本或者原key
 */
var formatKeyValue = exports.formatKeyValue = function formatKeyValue(key, optionsObj, needDebug) {
  if (!key || (0, _typeof2.default)(optionsObj) !== 'object') {
    return '';
  }
  var txt = key || '';
  optionsObj.some(function (item) {
    var bool = item.code === key;
    if (bool) {
      txt = item.name;
    }
    return bool;
  });
  if (needDebug) {
    console.log("\u5339\u914D\u5230\u7684\u503C\u4E3A: ".concat(txt, " key: ").concat(key, "; options: ").concat(optionsObj, ";"));
  }
  return txt;
};

/**
 * 下载excel文件
 * @param {string} name // 文件base名称
 * @param {*} content // 下载内容
 * @param {*} isCustomName // 已自定义name，不作修改
 */
var downloadFileExcel = exports.downloadFileExcel = function downloadFileExcel(name, content) {
  var isCustomName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var fileName = isCustomName ? name : "".concat(name).concat(parseTime(new Date().getTime()), ".xlsx"); // 保存的文件名
  var elink = document.createElement('a');
  elink.download = fileName;
  elink.style.display = 'none';
  var blob = new Blob([content], {
    type: 'application/vnd.ms-excel'
  });
  elink.href = URL.createObjectURL(blob);
  document.body.appendChild(elink);
  elink.click();
  document.body.removeChild(elink);
};

/**
 * 数据标准化(千分位逗号)
 * @param {*} inputNum
 * @returns {*} 标准化后的字符串
 */
var paddingNum = exports.paddingNum = function paddingNum(inputNum) {
  // 判断入参是否为有效数字
  if (!isNaN(parseFloat(inputNum)) && isFinite(inputNum)) {
    var flag = inputNum >= 0;
    var numArr = Math.abs(inputNum).toString().split('.');
    var right = numArr[1] ? '.' + numArr[1] : ''; // 小数点右边的数字
    var left = numArr[0]; // 小数点左边的数字
    var temp = '';
    while (left.length > 3) {
      // str.slice(start, end); 截取字符串，返回截取的字符串，end取不到
      temp = ',' + left.slice(-3) + temp;
      left = left.slice(0, left.length - 3);
    }
    return flag ? left + temp + right : '-' + left + temp + right;
  } else {
    return '-';
    // return inputNum
  }
};

/**
 * 月份英文表示
 * @param {*} inputMonth
 * @returns {string} 英文月份缩写
 */
var monthTransToEn = exports.monthTransToEn = function monthTransToEn(inputMonth) {
  var monthNum = parseInt(inputMonth);
  switch (monthNum) {
    case 1:
      return 'Jan';
    case 2:
      return 'Feb';
    case 3:
      return 'Mar';
    case 4:
      return 'Apr';
    case 5:
      return 'May';
    case 6:
      return 'Jun';
    case 7:
      return 'Jul';
    case 8:
      return 'Aug';
    case 9:
      return 'Sep';
    case 10:
      return 'Oct';
    case 11:
      return 'Nov';
    case 12:
      return 'Dec';
  }
};
/**
 * 转化百分比
 * @param {*} point 
 * @returns 
 */
var toPercent = exports.toPercent = function toPercent(point) {
  var str = Number(point).toString();
  if (point > 0) {
    if (str.split('.')[1] && str.split('.')[1].length > 2) {
      str = Number(point * 100).toFixed(1);
    } else {
      str = Number(point * 100).toFixed(0);
    }
  }
  str += "%";
  return str;
};

/**
 * 角色映射
 * @param {*} roleCode
 * @returns
 */
var getRoleName = exports.getRoleName = function getRoleName(roleCode) {
  if (roleCode === 'RSM') {
    return 'Region Head';
  }
  return roleCode;
};